import {localURL, injurySummaryApi, allInjurySummaryApi} from '../../constants/apiConstants';
import mode from '../mode';
import {createFetchAndCall} from '../fetch/fetchServices';
import {createInjurySummaryDataObject} from '../../components/injurySummary/injurySummaryModel';

class injurySummary {
  static createInjurySummary(summary) {
    let injurySummaryApiPath = createInjurySummaryApi(injurySummaryApi);
    let headers = {
      'accept': 'application/json',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache'
    };
    let options = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(createInjurySummaryDataObject(summary))
    };
    return createFetchAndCall(injurySummaryApiPath, options);
  }

  static getInjurySummary(link) {
    link = createInjurySummaryApi(link);
    let headers = {
      'accept': 'application/json'
    };
    let options = {
      method: 'GET',
      headers: headers
    };
    return createFetchAndCall(link, options);
  }

  static getAllInjurySummary(establishmentId) {
    let link = createAllInjurySummaryApi(allInjurySummaryApi, establishmentId);
    let headers = {
      'accept': 'application/json'
    };
    let options = {
      method: 'GET',
      headers: headers
    };
    return createFetchAndCall(link, options);
  }

  static editInjurySummary(summary, formId) {
    let injurySummaryApiPath =
      createInjurySummaryApi(injurySummaryApi, formId);
    let headers = {
      'accept': 'application/json',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache'
    };
    let options = {
      method: 'PATCH',
      headers: headers,
      body: JSON.stringify(createInjurySummaryDataObject(summary))
    };
    return createFetchAndCall(injurySummaryApiPath, options);
  }
}

function createInjurySummaryApi(link, formId) {
  if(formId) {
    link = `${link}/${formId}`;
  }
  if (!mode.prod) {
    link = `${localURL}${link}`;
  }
  return link;
}

function createAllInjurySummaryApi(link, establishmentId) {
  if(establishmentId) {
    link = `${link}/${establishmentId}`;
  }
  if (!mode.prod) {
    link = `${localURL}${link}`;
  }
  return link;
}

export default injurySummary;



/** WEBPACK FOOTER **
 ** ./src/api/forms/injurySummaryApi.js
 **/